// extracted by mini-css-extract-plugin
export default {"ns_not_found_page":"NSNotFoundPage_ns_not_found_page__S862O"};